export default __webpack_public_path__ + "static/award-ceremony-8bb65544dd12f681b58017f01571f2ed.webp";